;(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const pageType = document.querySelector('body')
    if (pageType.classList.contains('template-product')) {
      const samedayIcon = document.getElementById('selected-delivery-icon')
      const samedayInfo = document.querySelector('.Sameday__Info')
      const newValue = document.querySelector('.ProductForm__SelectedValue')

      if (samedayIcon && samedayInfo && newValue) {
        const locationTitles = JSON.parse(samedayIcon.dataset.locationTitles)
        if (locationTitles.includes(newValue.innerText)) {
          samedayIcon.style.display = 'inline'
          samedayInfo.style.display = 'block'
        } else {
          samedayIcon.style.display = 'none'
          samedayInfo.style.display = 'none'
        }
      }
    }

    if (Shopify?.Checkout?.step === 'shipping_method') {
      let interval = setInterval(() => {
        const boxes = document.querySelectorAll(
          '.section--shipping-method .content-box__row'
        )
        if (boxes.length > 0) {
          for (const box of boxes) {
            const label = box.querySelector('.radio__label__primary')
            if (
              label &&
              label.innerText.toLowerCase().includes('local delivery')
            ) {
              label.innerHTML = label.innerHTML.replace(
                'Local delivery',
                'Same day courier service'
              )
              if (document.body.dataset.sameday !== 'true') {
                box.style.display = 'none'
              }
            }
          }

          clearInterval(interval)
          interval = null
        }
      }, 100)
    }

    if (Shopify?.Checkout?.step === 'contact_information') {
      let interval = setInterval(() => {
        const boxes = document.querySelectorAll(
          '.section--shipping-address .section__content .content-box__row'
        )
        if (boxes.length > 0) {
          for (const box of boxes) {
            const label = box.querySelector('.radio__label__primary')
            if (label && label.innerText.toLowerCase().includes('pick up')) {
              if (document.body.dataset.sameday !== 'true') {
                box.style.display = 'none'
              }
            }
          }

          clearInterval(interval)
          interval = null
        }
      }, 100)
    }
  })
})()
